import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import type { Property } from "../property-type";

const useStyles = makeStyles((theme) => ({
  propertyContainer: {
    alignItems: "center",
    "& pre": {
      fontFamily: theme.typography.fontFamily,
    },
  },
  printValue: {
    display: "inline-block",
    marginLeft: theme.spacing(1),
  },
  printLabel: {
    display: "inline-block",
  },
  printWrapper: {
    marginBottom: "4px",
  },
}));

interface InvestigationResultsProps {
  items: [Property, React.ReactElement][];
  print?: boolean;
}

const InvestigationResults = ({
  items,
  print,
}: InvestigationResultsProps): React.ReactElement => {
  const classes = useStyles();

  return (
    <Grid container spacing={print ? 0 : 2}>
      {items.map(([property, content]) => {
        const { title, meta, type } = property;
        const isCustomComponent = !!meta?.component;

        if (print) {
          return (
            <Grid item xs={12} className={classes.printWrapper} key={title}>
              <Box className={classes.printLabel}>
                <Typography variant="body1">
                  <strong>{`${title}:`}</strong>
                </Typography>
              </Box>
              <Box className={classes.printValue}>{content}</Box>
            </Grid>
          );
        }

        if (!isCustomComponent && type === "object") {
          return (
            <Grid item xs={12} key={title}>
              <Box mb={1}>
                <Typography variant="body1">
                  <strong>{title}</strong>
                </Typography>
              </Box>
              <Box pl={2}>{content}</Box>
            </Grid>
          );
        }

        return (
          <Grid item xs={12} key={title}>
            <Grid container spacing={2} className={classes.propertyContainer}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2">
                  <strong>{title}</strong>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                {content}
              </Grid>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};

InvestigationResults.defaultProps = {
  print: false,
};

export default InvestigationResults;
